import { lazy } from 'react'

const RELOAD_KEY = 'style_ai_chunk_reload_at'
const RELOAD_GUARD_MS = 60 * 1000

const CHUNK_ERROR =
  /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed|Unable to preload CSS|ChunkLoadError|Loading (CSS )?chunk [\w-]+ failed|Expected a JavaScript module script|is not a valid JavaScript MIME type/i

export function isChunkLoadError(error) {
  if (!error) return false
  return CHUNK_ERROR.test(`${error.name || ''} ${error.message || error}`)
}

/**
 * Reload once to pick up the new deploy's index.html and chunk names.
 * Returns false when we already reloaded recently (or storage is unavailable),
 * so a broken deploy shows the error screen instead of looping.
 */
export function reloadOnceForNewDeploy() {
  if (typeof window === 'undefined') return false
  try {
    const last = Number(window.sessionStorage.getItem(RELOAD_KEY))
    if (Number.isFinite(last) && Date.now() - last < RELOAD_GUARD_MS) return false
    window.sessionStorage.setItem(RELOAD_KEY, String(Date.now()))
  } catch {
    return false
  }
  window.location.reload()
  return true
}

/** React.lazy that reloads the page once when a route chunk from an older deploy is gone. */
export function lazyWithReload(factory) {
  return lazy(() =>
    factory().catch((error) => {
      if (isChunkLoadError(error) && reloadOnceForNewDeploy()) {
        return new Promise(() => {})
      }
      throw error
    })
  )
}

export function installPreloadErrorReload() {
  if (typeof window === 'undefined') return
  window.addEventListener('vite:preloadError', (event) => {
    if (reloadOnceForNewDeploy()) event.preventDefault()
  })
  window.addEventListener('unhandledrejection', (event) => {
    if (isChunkLoadError(event.reason)) reloadOnceForNewDeploy()
  })
}
